export  default class LotteryRecords {
    id:number;
    userid:string;
    name:string;
    campaignCode:string;
    giftName:string;
    giftCode:string;
    sendNum:number;
    createTime:string;
}